<template>
  <div class="flex flex-fill flex-row v-center">
    <el-checkbox
      v-if="allowedCheck"
      v-model="checkedValue"
      :label="value"
      :indeterminate="indeterminate"
      >{{ "" }}</el-checkbox
    >
    <span class="flex-fill"
      ><slot name="label">{{ label }}</slot></span
    >
    <i v-if="!isLeaf" class="el-icon-arrow-right" />
  </div>
</template>
<script>
import { Icon, Checkbox } from "element-ui";
export default {
  name: "check-item",
  components: {
    [Checkbox.name]: Checkbox,
    [Icon.name]: Icon,
  },
  props: {
    label: {
      type: String,
    },
    checked: {
      type: Boolean,
    },
    indeterminate: {
      type: Boolean,
    },
    isLeaf: {
      type: Boolean,
    },
    value: {
      type: [String, Number, Boolean],
    },
    allowedCheck: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    checkedValue: {
      get() {
        return this.$props.checked;
      },
      set(value) {
        this.$emit("update:checked", value);
        this.$emit("change", { value: this.$props.value, checked: value });
      },
    },
  },
};
</script>
